<div app-landing-page-section-container class="pt-5 lg:pt-10">
    <div class="flex flex-col-reverse xl:flex-row gap-8 xl:gap-4">
        <div>
            <div translate class="mat-headline-6 pb-8 md:pb-10">
                LandingPageFleetManagementTitle
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div class="flex flex-col">
                    <div class="flex items-center pb-4">
                        <mat-icon svgIcon="contract-management"></mat-icon>
                        <translate class="mat-subtitle-2"
                            >Contract Management</translate
                        >
                    </div>
                    <div class="pb-2" translate>
                        LandingPageFleetManagementContracts
                    </div>
                </div>
                <div class="flex flex-col">
                    <div class="flex items-center pb-4">
                        <mat-icon svgIcon="fleet-management"></mat-icon>
                        <translate class="mat-subtitle-2"
                            >Fleet Management</translate
                        >
                    </div>
                    <div class="pb-2" translate>
                        LandingPageFleetManagementFleet
                    </div>
                </div>
                <div class="flex flex-col">
                    <div class="flex items-center pb-4">
                        <mat-icon svgIcon="notifications"></mat-icon>
                        <translate class="mat-subtitle-2"
                            >Notifications</translate
                        >
                    </div>
                    <div class="pb-2" translate>
                        LandingPageFleetManagementNotifications
                    </div>
                </div>
                <div class="flex flex-col">
                    <div class="flex items-center pb-4">
                        <mat-icon svgIcon="group-management"></mat-icon>
                        <translate class="mat-subtitle-2"
                            >Group Management</translate
                        >
                    </div>
                    <div class="pb-2" translate>
                        LandingPageFleetManagementGroupManagement
                    </div>
                </div>
            </div>
        </div>
        <div
            [ngClass]="[
                'flex items-center',
                'bg-primary-dark rounded-xl',
                'lg:min-w-[440px] lg:max-w-[440px]',
                'xl:p-0 xl:ml-8 xl:min-w-[360px]',
            ]"
        >
            <app-lottie
                class="hidden xl:block"
                path="/assets/animations/landing-page/support/data.json"
                [aspectRatio]="[1, 1]"
            >
            </app-lottie>
            <app-lottie
                class="xl:hidden sm:min-h-[440px] sm:max-h-[440px]"
                path="/assets/animations/landing-page/support/data.json"
                [aspectRatio]="[1, 1]"
                cropTop="6.5%"
                cropBottom="20%"
            >
            </app-lottie>
        </div>
    </div>
</div>
